export const selectOptions = [
  {
    key: '1c',
    label: 'Review information availability on the organisation',
  },
  {
    key: '2c',
    label: 'Review KYC progress per section',
  },
  {
    key: '3c',
    label: 'Assess information availability progress over time',
  },
  {
    key: '4c',
    label: 'Visualise beneficiary and control structure of the organisation',
  },
  {
    key: '5c',
    label: 'Access compliance indicators',
  },
  {
    key: '6c',
    label: 'Review the compliance of the organisation over time',
  },
  {
    key: '7c',
    label: 'Review evolution of challenges over time',
  },
  {
    key: '8c',
    label: 'Access the list of all KYC checks performed on the organisation',
  },
  {
    key: '9c',
    label: 'Verify status of documentation on the organisation',
  },
  {
    key: '10c',
    label: 'Review the organisation’s conformance to Step 1 of the OECD Guidance',
  },
  {
    key: '11c',
    label: 'List of all open challenges related to the organisation',
  },
  {
    key: '12c',
    label: 'Visualise the organisation’s supply chain based on available information',
  },
];
